import React, { useEffect } from 'react'
import Connect from "../../../shared/redux/Connect.hoc";
import { withRouter, Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next'
import { FaTrash, FaEye } from 'react-icons/fa'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import './styles.scss'

// ? Redux
import { getMensajeria, setMensajeria } from '../../../shared/redux/action/mensajeria.action'

const pagination = paginationFactory({
  page: 1,
  sizePerPage: 10
})
const { SearchBar } = Search

const MensajeriaTable = ({ state, dispatch, servicios, openDetalle }) => {

  const renderColumns = () => {
    console.log("--MensajeriaTable.Table.renderColumns-- ");
    return [
      {
        dataField: 'index',
        text: '#',
        sort: true,
        headerStyle: () => {
          return { width: "5%" };
        }
      },
      {
        dataField: 'paquete',
        text: 'Tipo Paquete',
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        }
      },
      {
        dataField: 'estado',
        text: 'Estado',
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        }
      },
      {
        dataField: 'distancia',
        text: 'Distancia (Km)',
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        }
      },
      {
        dataField: 'tecnico.name',
        text: 'Mensajero',
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        }
      },
      {
        dataField: 'options',
        text: '',
        headerStyle: () => {
          return { width: "10%" };
        },
        formatter: (cellContent, row) => (
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
            <div style={{ cursor: 'pointer' }} >
              <FaEye />
            </div >
          </div>
        )
      }
    ]
  }

  const renderData = () => {
    console.log("--MensajeriaTable.Table.renderServicios-- ");
    if (servicios !== undefined && servicios !== null && Array.isArray(servicios)) {
      return servicios.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        }
      })
    }
    return []
  }

  const rowEvents = {
    onClick: async (e, row, rowIndex) => {
      console.log("--MensajeriaTable.Table.rowEvents-- ");
      const mensajeria = row
      console.log("--MensajeriaTable.Table.rowEvents-- mensajeria: ", mensajeria);
      dispatch(await getMensajeria(mensajeria))
      openDetalle()

    }
  }

  return (
    <div className="container">
      <div className="row row-table">
        <div className="col">
          <ToolkitProvider
            keyField="id"
            data={renderData()}
            columns={renderColumns()}
            search>
            {
              props => (
                <div>
                  <div className="clearfix">
                    <div className="float-left search-container">
                      <SearchBar style={{borderRadius:'20px'}} {...props.searchProps} placeholder="Buscar" />
                    </div>
                  </div>
                  <div className={`card shadow h-100 card-table`}>
                    <div className="card-body">

                      <BootstrapTable
                        {...props.baseProps}
                        pagination={pagination}
                        bordered={false}
                        striped={false}
                        bootstrap4={true}
                        rowEvents={rowEvents}
                        noDataIndication="No has generado ningún servicio aún, qué esperas?"
                      />
                    </div>
                  </div>

                </div>
              )
            }
          </ToolkitProvider>
        </div>
      </div>
    </div>
  )

}

export default withRouter(Connect(MensajeriaTable))